import { graphql, PageProps } from "gatsby";
import React from "react";
import DocumentHead, { PageSeoType } from "../components/DocumentHead/DocumentHead";
import HeroWithOverlay from "../components/HeroWithOverlay";
import Layout from "../components/Layout";
import PortableText from "../components/PortableText";
import { PortableTextColorTheme } from "../components/PortableText/PortableText";
import siteConfig from "../config/siteConfig";
import { GatsbyPageContext } from "../models/pages/GatsbyPageContext";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StartPage = ({ data, pageContext }: PageProps<any, GatsbyPageContext>) => {
  const { startPage } = data;

  return (
    <Layout
      pageContext={pageContext}
      transparentHeader={siteConfig.isGroup}
      hero={
        <HeroWithOverlay
          image={startPage.heroImage}
          title={startPage.title}
          subtitle={startPage.subtitle}
          ctaButton={startPage.heroCtaButton}
          backgroundPattern={startPage.heroBackgroundPattern}
          makeRoomForHeader={siteConfig.isGroup}
        />
      }
      isStartPage
    >
      <DocumentHead
        pageData={startPage}
        pageSeoType={PageSeoType.Organization}
        canonical={pageContext.currentPath}
      />
      {startPage._rawPortableTextContent && (
        <PortableText
          _rawBody={startPage._rawPortableTextContent}
          colorTheme={PortableTextColorTheme.Neutral}
        />
      )}
    </Layout>
  );
};

export const query = graphql`
  query GetStartPageQuery($_id: String!) {
    startPage: sanityStartPage(_id: { eq: $_id }) {
      title
      subtitle
      heroImage {
        ...SanityImageExtFragment
      }
      heroBackgroundPattern {
        ...SanityBackgroundPatternFragment
      }
      heroCtaButton {
        ...SanityLinkFragment
      }
      heroPhoneNumber
      _rawPortableTextContent(resolveReferences: { maxDepth: 7 })
      seo {
        ...SanitySeoPropertiesFragment
      }
      socialMedia {
        ...SanitySocialMediaPropertiesFragment
      }
    }
  }
`;

export default StartPage;
